import Navbar from "../components/Navbar"
import Footer from "../components/Footer"

const members = [
  ["Uday", "Full Stack / ML Engineer"],
  ["Vaishnavi", "Dataset & Testing"],
  ["Akash Rao", "Model Training"],
  ["Srilekha", "UI/UX"],
  ["Akshaya Reddy", "Research Analysis"],
  ["Dr. Gagandeep Arora", "Research Mentor"],
]

export default function Team(){

return(

<div className="app-shell">

<Navbar/>

<section className="page-section">
<div className="section-shell px-6">
<div className="content-card rounded-[2rem] p-8 md:p-12">

<div className="eyebrow">People</div>

<h1 className="mb-10 mt-6 text-4xl font-bold text-stone-900 md:text-5xl">

Research Team

</h1>

<div className="grid gap-6 md:grid-cols-2 xl:grid-cols-3">

{members.map(([name, role]) => (
<div key={name} className="info-panel rounded-[1.5rem] p-6">
<h3 className="text-2xl font-bold text-stone-900">{name}</h3>
<p className="mt-3 text-base leading-7 text-stone-600">{role}</p>
</div>
))}

</div>

</div>
</div>
</section>

<Footer/>

</div>

)

}
